import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import axios from "axios";
import {  Link } from "react-router-dom";
import estilos from "./EmailConfirm.module.css"
import HeaderSmall from "../../../components/HeaderSmall/HeaderSmall";
import BotonColor from "../../../components/BotonColor/BotonColor";

export function EmailConfirm() {
  //const navigate = useNavigate();
  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await axios.post(`${BASE_API}/api/password_reset/`, {
          email: formValue.email,
        });
        toast.success("Correo electrónico enviado, siga las instrucciones");
        formik.resetForm();
        return response;
      } catch (error) {
        toast.error(
          "No pudimos encontrar una cuenta asociada con ese correo electrónico. Por favor intente con una dirección de correo electrónico diferente."
        );
      }
    },
  });

  //const handleRegresarClick = () => {
    //navigate("/");
  //};

  function initialValues() {
    return {
      email: "",
    };
  }

  function newSchema() {
    return {
      email: Yup.string().email(true).required(true),
    };
  }

  return (
    <div className={estilos.contenedor}>
    <div
      className={estilos.rectangulo}
      onSubmit={formik.handleSubmit}
    >
       <HeaderSmall
       btTitulo="Recuperar contraseña"/>
      
      <Form className={estilos.formpersonalizado}>
        <div>
        <h5 className={estilos.etiq}>Ingrese su correo electrónico:</h5>
        <Form.Input
          name="email"
          placeholder="Correo electrónico"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.errors.email}
          className={estilos.inform}
        />
        </div>
        <BotonColor
          type="submit"
          btnTitulo="Enviar"
        />
      </Form>
      <ToastContainer/>
      <Link
            to="/login"
            className={estilos.linkf}
          >
            Iniciar sesión
          </Link>
    </div>
    </div>
  );
}
